import numeral from 'numeral'
import Modal from 'com/Modal'
import { ORDER_TYPE } from 'const/trade'
import getPriceMinTick from 'utils/getPriceMinTick'
import getPriceAccuracy from 'utils/getPriceAccuracy'

let warningModal = null

export default {
  computed: {
    minTicks() {
      return this.contract ? this.contract.tickSizes : []
    },
    canShort() {
      return this.contract ? this.contract.canShort : false
    },
    priceList() {
      const price = [this.order.limitPrice]
      if (this.order.profitTakerPrice) {
        price.push(this.order.profitTakerPrice)
      }
      if (this.order.stopLossPrice) {
        price.push(this.order.stopLossPrice)
      }
      return price
    }
  },
  methods: {
    validateOrder(onSuccess) {
      if (warningModal) return warningModal.confirm()

      // 检查链。返回三种情况
      // true 表示输入正常
      // false 表示输入异常但是无提示
      // [message] 表示返回提示消息，需要弹窗
      const chainsValid = [
        this.checkQuantity(),
        this.checkAddOrder(),
        this.checkLimitPrice(),
        this.checkHoldingPosition()
      ]
      let isValid = true
      let warningContent = ''
      chainsValid.forEach(v => {
        if (v === true) return
        isValid = false
        if (v) warningContent += `<p class="paragraph">${v}</p>`
      })
      if (isValid) return onSuccess && onSuccess()
      if (warningContent) {
        warningModal = Modal.open({
          title: this.$t('trade.trade-warning-title'),
          content: warningContent,
          style: { textAlign: 'justify' },
          okText: this.$t('continue'),
          cancelText: this.$t('back'),
          wrapClassName: 'trade-warning-modal',
          onConfirm: () => {
            onSuccess && onSuccess()
          },
          onClose: () => {
            warningModal = null
          }
        })
      }
    },
    // 检查持仓
    checkHoldingPosition() {
      if (this.order.action === 'SELL') {
        // 卖单如果卖出数量大于持仓则存在卖空
        const shortQuantity = this.positionNum - this.order.totalQuantity
        if (shortQuantity < 0) {
          if (this.canShort) {
            // 可做空。展示做空提醒
            const i18nMessage = this.isOPT
              ? 'trade.trade-option-short-warning'
              : 'trade.trade-short-warning'
            return this.$t(i18nMessage, [this.highlight(shortQuantity)])
          } else {
            // 不可做空。非期权展示不可做空提醒
            if (!this.isOPT) {
              return this.$t('trade.trade-cannot-short-warning', [
                this.highlight(this.order.totalQuantity)
              ])
            }
          }
        }
      }
      return true
    },
    // 只检查订单限价（因为只有限价会约束订单交易价格）
    checkLimitPrice() {
      if (this.isLMT) {
        let warningContent = ''
        this.priceList.forEach(price => {
          const minTick = getPriceMinTick(price, this.minTicks)
          if (
            Number.isInteger(
              numeral(price)
                .divide(minTick)
                .value()
            )
          ) {
            return
          }
          const accuracy = getPriceAccuracy(minTick)
          if (this.isOPT) {
            warningContent += this.$t('trade.trade-price-warning-option', [
              this.highlight(minTick)
            ])
          }
          if (this.isHK) {
            warningContent += `${this.$t('trade.trade-price-warning', [
              this.highlight(accuracy),
              this.highlight(minTick),
              this.highlight(price)
            ])}\n`
          }
        })
        if (warningContent) return warningContent
      }
      return true
    },
    // 检查附加订单
    checkAddOrder() {
      // 止盈单
      if (
        [ORDER_TYPE.BRACKETS, ORDER_TYPE.PROFIT].includes(
          this.order.attachOrderType
        )
      ) {
        if (this.order.profitTakerPrice <= 0) return false
      }
      // 止损单
      if (
        [ORDER_TYPE.BRACKETS, ORDER_TYPE.LOSS].includes(
          this.order.attachOrderType
        )
      ) {
        if (this.order.stopLossPrice <= 0) return false
      }
      return true
    },
    // 检查订单数量
    checkQuantity() {
      if (this.order.totalQuantity > 0) {
        const lotSize = this.stock.lotSize || 1
        if (this.order.totalQuantity % lotSize === 0) return true
        return this.$t('trade.trade-quantity-warning', [
          this.stock.nameCN,
          this.stock.symbol,
          this.highlight(lotSize),
          this.highlight(this.order.totalQuantity)
        ])
      }
      this.focusQuantityField()
      return false
    },
    highlight(content) {
      return `<span class="highlight">${content}</span>`
    },
    // 重新聚焦数量输入框
    focusQuantityField() {
      const quantity = document.querySelector('.order-quantity input')
      quantity && quantity.focus()
    }
  }
}
